<template>
  <div id="app">
    <div class="wraper">
      <a class="ttt" id="ttt" href="#" style="display: block;"><img src="@/assets/tothetop.png"></a>
      <div class="header" id="header">
        <div class="navbar" id='navbar' :class="{'tops': top > 1}">
          <div class="navbar-box">
            <img alt="部盾科技" class="logo" src="@/assets/logo-bai.png" v-if="top > 1">
            <img alt="部盾科技" class="logo" src="@/assets/logo.png" v-else>
            <ul class="menubar">
              <li :style="{ 'color': title == '首页' ? 'red' : ''}" @click="goView('Index')">首页</li>
              <li :style="{ 'color': title == '产品介绍' ? 'red' : ''}"  @click="goView('introduction')">产品介绍</li>
              <li :style="{ 'color': title == '关于我们' ? 'red' : ''}"  @click="goView('AboutUs')">关于我们</li>
              <li  :style="{ 'color': title == '行业聚焦' ? 'red' : ''}" class="hyjj-route">
                行业聚焦
                <div class="submenu">
                  <a class="submenu-items" style="font-size: 16px;" @click="goView('government')">政府大数据</a>
                  <a class="submenu-items" style="font-size: 16px;" @click="goView('enterprise')">企业大数据</a>
                  <a class="submenu-items" style="font-size: 16px;" @click="goView('education')">教育与培训</a>
                </div>
              </li>
              <li :style="{ 'color': title == '最新资讯' ? 'red' : ''}" @click="goView('news')">最新资讯</li>
              <li :style="{ 'color': title == '联系我们' ? 'red' : ''}" @click="goView('ContactUs')">联系我们</li>
              
            </ul>
          </div>
        </div>
      </div>

      <div id="body">
        <div id="flash-messages" class="container">
          <router-view />
          <!-- <div class="alert alert-info">
          </div>
          <div class="alert alert-success">
          </div>
          <div class="alert alert-warning">
          </div>
          <div class="alert alert-danger">
          </div> -->
        </div>
      </div>
      <footer class="footer">
        <img class="footer-bg" src="@/assets/dibu.png" alt="">
        
        <div class="footer-cont">
          <ul class="footer-list">
            <li class="footer-li first">关于我们</li>
            <a @click="goView('AboutUs')"><li class="footer-li">部盾科技信息</li></a>
            <a @click="goView('news')"><li class="footer-li">新闻中心</li></a>
            <a @click="goView('introduction')"><li class="footer-li">产品介绍 </li></a>
          </ul>
          <ul class="footer-list">
            <li class="footer-li first">行业服务</li>
            <a @click="goView('government')"><li class="footer-li">政府大数据</li></a>
            <a @click="goView('enterprise')"><li class="footer-li">大数据教学</li></a>
            <a @click="goView('education')"><li class="footer-li">企业大数据</li></a>
          </ul>
          <ul class="footer-list">
            <li @click="goView('ContactUs')" class="footer-li first">联系我们</li>
            <li class="footer-li">400-699-8565</li>
          </ul>
          <ul class="footer-list">
            <li class="footer-li first">商业合作</li>
            <li class="footer-li">info@bu-dun.com</li>
          </ul>
          <img class="footer-logo" src="@/assets/logo-footer.png" alt="">
        </div>
        <div class="footer-beian">
          <p>Copyright 部盾[<a style="text-decoration: none;color: inherit;font-weight:normal;" href="https://beian.miit.gov.cn/" target="_blank">京ICP备19035117号-1</a>] 2018-2019.ALL Rights Reserved.</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
      return {
        top: 0,
        title: '',
      };
  },
  methods: {
    goView(name) {
      this.$router.push({name: name})
    },
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.title = this.$route.meta.title
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted() {
    this.title = this.$route.meta.title
    var vm = this
    $(window).scroll(function () { //开始监听滚动条
      //获取当前滚动条高度
      vm.top = $(document).scrollTop();
    })
  },
}
</script>

<style scoped>
   
</style>